






























import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import { store } from "@/store/store";
import { ApiResponse } from "@/types/types";
import { Device_ } from "@/store/modules/Device/interface";
import Csv from "@/plugins/csv";
import { DeviceActionsTypes } from "@/store/modules/Device/types";
import { Response_ } from "@/plugins/axios/response";

interface DeviceCreateMultipleModalData {
  loading: boolean;
  devices: Array<Device_>;
}

export default Vue.extend({
  name: "DeviceCreateMultipleModal",
  components: { Modal },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onAction: {
      type: Function,
      default: () => undefined
    }
  },
  data(): DeviceCreateMultipleModalData {
    return {
      loading: false,
      devices: []
    };
  },
  methods: {
    async verifyCsv(file: File): Promise<void> {
      const csv = new Csv();
      let material_array = csv.FromCsvToArray(await csv.readFileContent(file));
      material_array.forEach((material: any) => {
        material.sd = material.sd.toString();
      });
      this.devices = material_array as Array<Device_>;
    },
    async validate(): Promise<void> {
      this.loading = true;
      if (this.devices.length > 0) {
        const request_result = await this.createMultipleDevice({ devices: this.devices });
        if (
          (request_result as Response_).status === ApiResponse.CREATED ||
          (request_result as Response_).status === ApiResponse.SUCCESS
        ) {
          this.onAction({
            type: "SUCCESS",
            title: "Appareils crées",
            content: (request_result as Response_).message
          });
          this.loading = false;
          this.onClose();
          return;
        } else {
          this.onAction({
            type: "ERROR",
            title: "Erreur",
            content: (request_result as Response_).message
          });
        }
      }
      this.loading = false;
    },
    async createMultipleDevice(device_data: any): Promise<Response_> {
      return await store.dispatch(DeviceActionsTypes.CREATE_MULTIPLE_DEVICE, device_data);
    }
  }
});
